import { render, staticRenderFns } from "./ProjectCommunicationTable.vue?vue&type=template&id=22d935dc"
import script from "./ProjectCommunicationTable.vue?vue&type=script&lang=ts"
export * from "./ProjectCommunicationTable.vue?vue&type=script&lang=ts"
import style0 from "./ProjectCommunicationTable.vue?vue&type=style&index=0&id=22d935dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports